import React, { useState, useEffect, useMemo } from "react";
// import { useLocation, useHistory } from "react-router-dom";
import { useHistory } from "react-router-dom";
import {
  makeDealerOnboardStorageKey,
  loadPersistedDealerOnboard,
  savePersistedDealerOnboard,
} from "utils/persistForm";
// Safe fallback for reading navigation state without Router hooks
const getNavigationState = () => {
  if (typeof window === "undefined") return null;
  const st = window.history && window.history.state;
  return st?.usr || st?.state || null;
};

// Helper to derive dealerId from multiple sources
const getDealerId = () => {
  try {
    const st = getNavigationState();
    const fromState = st?.dealerId || st?.dealer_id || null;
    const fromQuery =
      typeof window !== "undefined"
        ? new URLSearchParams(window.location.search).get("dealerId")
        : null;
    const fromStorage =
      typeof window !== "undefined"
        ? window.localStorage.getItem("dealerId")
        : null;
    return fromState || fromQuery || fromStorage || null;
  } catch (_) {
    return null;
  }
};

// Helper: read auth token from localStorage
const getAuthToken = () => {
  try {
    if (typeof window === "undefined") return null;
    // primary key 'token', fallbacks if your app uses different keys
    return (
      window.localStorage.getItem("token") ||
      window.localStorage.getItem("authToken") ||
      window.localStorage.getItem("jwt") ||
      null
    );
  } catch (_) {
    return null;
  }
};
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  FormHelperText,
  TextField,
  Typography,
  Container,
  Grid,
  ListSubheader,
  Divider,
  Stack,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { toastMessage } from "utils/toastMessage";
import { getDealerData, getCustomerGroupData, getParticularDealerOnboardingData } from "_controllers/officer";
import AccessController from "_shared/AccessController";
import TopBar from "_shared/Top";
import { Toaster } from "react-hot-toast";
import { DashGridL2 } from "layouts/dash-grid";

const initialFormData = {
  // DROPDOWNS → { id, code, label }
  customer_group: {  code: "", label: "" },
  customer_pricing_procedure: {  code: "", label: "" },
  terms_of_payment: {  code: "", label: "" },
  // incoterms: {  code: "", label: "" },

  account_assignment_group: {  code: "", label: "" },
  // reconciliation_account: {  code: "", label: "" },
  account_group: {  code: "", label: "" },
  sales_office: {  code: "", label: "" },
  distribution_channel: {  code: "", label: "" },
  // division: {  code: "", label: "" },
  state: {  code: "", label: "" },
  customer_class: {  code: "", label: "" },
  status: {  code: "", label: "" },
  price_group: {  code: "", label: "" },
  price_list: {  code: "", label: "" },

  // TEXT → { code }
  // company_code: { code: "" },
  // sales_org: { code: "" },
  with_sas: { code: "" },
  // title: { code: "" },

  dealership_name: { code: "" },
  dealership_add:{ code: "" },
  // street_house_no: { code: "" },
  care_of: { code: "" },
  // street2: { code: "" },
  // street3: { code: "" },
  // street5: { code: "" },
  region: { code: "" },
  district: { code: "" },
  // different_city: { code: "" },
  mobile_phone: { code: "" },
  // telephone: { code: "" },
  // fax: { code: "" },
  // tax_number_3: { code: "" },
  pan: { code: "" },

  customer_statistic_group: { code: "" },
  delivering_plant: { code: "" },
  rebate: { code: "" },
  // incoterms1: { code: "" },
  // customer_segment: { code: "" },
  // credit_limit: { code: "" },
  payment_terms: { code: "" },
  // delivery_priority: { code: "" },
  // tax_classification: { code: "" },
  // language: { code: "" },
  // sales_district: { code: "" },
  // sales_group: { code: "" },
  // price_list_group: { code: "" },
  // incoterm_location: { code: "" },
  // billing_block: { code: "" },
  // shipping_condition: { code: "" },
  // customer_status: { code: "" },
  // account_manager: { code: "" },
  // sales_channel: { code: "" },
  // distribution_method: { code: "" },
  gst_number: { code: "" },
  latitude: { code: "" },
  longitude: { code: "" },
  city: { code: "" },
  postal_code: { code: "" },
  // country: { code: "" },
  contact_person: { code: "" },
  phone_number: { code: "" },
  email: { code: "" },
  address: { code: "" },
  ///
  populationOfCity:{ code: "" },
  regionalOffice:{ code: "" },
  noOfYearsBusiness:{ code: "" },
  passportDetails:{ code: "" },
  fatherName:{ code: "" },
  // spouseName:{ code: "" },
  dateOfBirth:{ code: "" },
  shopStatus:{ code: "" },
  nearestJKDealer:{ code: "" },
  nearestSteelWheel:{ code: "" },
  competitionBrandShop:{ code: "" },
  gstCertificate:{ code: "" ,imageUrl: ""},
  panCardPhoto:{ code: "" ,imageUrl: ""},
  cibilScoreCard:{ code: "" ,imageUrl: ""},
  adhaarcardFront:{ code: "" ,imageUrl: ""},
  adhaarcardBack:{ code: "" ,imageUrl: ""},
  chequeScan:{ code: "" ,imageUrl: ""}

};
let REACT_APP_REQUEST_ENDPOINT = process.env.REACT_APP_REQUEST_ENDPOINT;
// File validation configuration
const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB
const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp", "image/gif"];
// Centralized, easily editable validation helpers and rules
const validators = {
  requiredText: (value) => {
    const v = typeof value === "string" ? value : value?.code;
    return v && String(v).trim().length > 0;
  },
  requiredDropdown: (value) => {
    if (!value) return false;
    if (typeof value === "object") {
      return (value.code && String(value.code).trim() !== "") || !!value.id;
    }
    return String(value).trim() !== "";
  },
  email: (value) => {
    const v = typeof value === "string" ? value : value?.code;
    if (!v) return true; // optional unless combined with required
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v));
  },
  phone10: (value) => {
    const v = typeof value === "string" ? value : value?.code;
    if (!v) return true;
    return /^\d{10}$/.test(String(v));
  },
  pin6: (value) => {
    const v = typeof value === "string" ? value : value?.code;
    if (!v) return true;
    return /^\d{6}$/.test(String(v));
  },
  pan: (value) => {
    const v = typeof value === "string" ? value : value?.code;
    if (!v) return true;
    return /^[A-Z]{5}[0-9]{4}[A-Z]$/.test(String(v).toUpperCase());
  },
  gstin: (value) => {
    const v = typeof value === "string" ? value : value?.code;
    if (!v) return true;
    return /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/.test(String(v).toUpperCase());
  },
  number: (value) => {
    const v = typeof value === "string" ? value : value?.code;
    if (v === undefined || v === null || v === "") return true;
    return !isNaN(Number(v));
  },
};

const validationRules = {
  // SAP & Pricing
  customer_group: [{ fn: validators.requiredDropdown, message: "Select Customer Group." }],
  customer_pricing_procedure: [{ fn: validators.requiredDropdown, message: "Select Customer Pricing Procedure." }],
  terms_of_payment: [{ fn: validators.requiredDropdown, message: "Select Terms of Payment." }],
  account_assignment_group: [{ fn: validators.requiredDropdown, message: "Select Account Assignment Group." }],
  // reconciliation_account: [{ fn: validators.requiredDropdown, message: "Select Reconciliation Account." }],

  // Org Structure
  account_group: [{ fn: validators.requiredDropdown, message: "Select Account Group." }],
  // company_code: [{ fn: validators.requiredText, message: "Enter Company Code." }],
  // sales_org: [{ fn: validators.requiredText, message: "Enter Sales Org." }],
  sales_office: [{ fn: validators.requiredDropdown, message: "Select Sales Office." }],
  distribution_channel: [{ fn: validators.requiredDropdown, message: "Select Distribution Channel." }],
  // title: [{ fn: validators.requiredText, message: "Enter Title." }],

  // Customer Classification
  state: [{ fn: validators.requiredDropdown, message: "Select State." }],
  customer_class: [{ fn: validators.requiredDropdown, message: "Select Customer Class." }],
  status: [{ fn: validators.requiredDropdown, message: "Select Entity." }],
  price_group: [{ fn: validators.requiredDropdown, message: "Select Price Group." }],
  price_list: [{ fn: validators.requiredDropdown, message: "Select Price List." }],

  // Address
  dealership_name: [{ fn: validators.requiredText, message: "Enter Dealership Name." }],
  // street_house_no: [{ fn: validators.requiredText, message: "Enter Street/House No." }],
  city: [{ fn: validators.requiredText, message: "Enter City." }],
  address: [{ fn: validators.requiredText, message: "Enter Address." }],
  region: [{ fn: validators.requiredText, message: "Enter Region." }],
  district: [{ fn: validators.requiredText, message: "Enter District." }],
  postal_code: [
    { fn: validators.requiredText, message: "Enter Postal Code." },
    { fn: validators.pin6, message: "Postal Code must be 6 digits." },
  ],

  // Contact
  contact_person: [{ fn: validators.requiredText, message: "Enter Contact Person." }],
  // phone_number: [{ fn: validators.phone10, message: "Enter 10-digit Landline/Mobile." }],
  mobile_phone: [{ fn: validators.phone10, message: "Enter 10-digit Mobile." }],
  email: [{ fn: validators.email, message: "Enter a valid Email." }],

  // Tax & Compliance
  gst_number: [{ fn: validators.gstin, message: "Enter valid GST Number." }],
  pan: [{ fn: validators.pan, message: "Enter valid PAN." }],
  // Note: with_sas is validated separately via SAS rules; kept as non-blocking
  
  // Documents (toggle required as per business need)
  gstCertificate: [{ fn: validators.requiredText, message: "Upload GST Certificate." }],
  panCardPhoto: [{ fn: validators.requiredText, message: "Upload PAN Card." }],
  cibilScoreCard: [{ fn: validators.requiredText, message: "Upload CIBIL Score Card." }],
  adhaarcardFront: [{ fn: validators.requiredText, message: "Upload Aadhaar Front." }],
  adhaarcardBack: [{ fn: validators.requiredText, message: "Upload Aadhaar Back." }],
  chequeScan: [{ fn: validators.requiredText, message: "Upload Cheque Scan." }],
};

// Static options for selects
const ACCOUNT_ASSIGNMENT_GROUP_OPTIONS = [
  { code: "domestic_revenues", name: "Domestic Revenues" },
  { code: "domestic_replacement", name: "Domestic Replacement" },
  { code: "mobility", name: "Mobility" },
  { code: "inter_comp", name: "Inter Comp" },
  { code: "other", name: "Other" },
];
const RECONCILIATION_ACCOUNT_OPTIONS = [
  { code: "advance_replacement", name: "Advance Replacement" },
  { code: "sas_deposit_replace", name: "SAS Deposit Replace" },
  { code: "customer_replace", name: "Customer Replace" },
  { code: "others", name: "Others" },
];
const PRICE_GROUP_OPTIONS = [
  { code: "dealer", name: "Dealer" },
  { code: "distributor", name: "Distributor" },
  { code: "fleet", name: "Fleet" },
  { code: "others", name: "Others" },
];
const PRICE_LIST_OPTIONS = PRICE_GROUP_OPTIONS;
const DOCUMENT_UPLOADS = [
  { key: "gstCertificate", label: "GST Certificate" },
  { key: "panCardPhoto", label: "PAN Card" },
  { key: "cibilScoreCard", label: "CIBIL Score Card" },
  { key: "adhaarcardFront", label: "Aadhaar Card Front" },
  { key: "adhaarcardBack", label: "Aadhaar Card Back" },
  { key: "chequeScan", label: "Cheque Scan" },
];

// Helper to detect if a string is a URL
const isHttpUrl = (value) => {
  if (!value || typeof value !== "string") return false;
  return /^https?:\/\//i.test(value);
};

const brandData = {
  "Tyre-Group-1": ["SW", "AW"],
  "Tyre-Group-2": ["12", "13"],
};

// Select that emits { id, code, label }, selects by _id (for master data)
const SelectField = ({
  label,
  fieldKey,
  options = [],
  value,
  onChange,
  required = true,
  error = false,
  errorMessage = "",
}) => (
  <FormControl fullWidth margin="normal" size="small" required={required} error={error}>
    <InputLabel required={required}>{label}</InputLabel>
    <Select
      value={value?.id || ""}
      label={label}
      onChange={(e) => {
        const opt = options?.find(
          (o) => String(o._id) === String(e.target.value)
        );
        onChange(
          fieldKey,
          opt
            ? {
                id: opt._id,
                code: opt.code || "",
                label: opt.description || opt.name || "",
              }
            : {  code: "", label: "" }
        );
      }}
    >
      {options?.map((item) => (
        <MenuItem key={item._id || item.code} value={item._id || ""}>
          {item.description || item.name || ""}{" "}
          {item.code ? `(${item.code})` : ""}
        </MenuItem>
      ))}
    </Select>
    {error && errorMessage ? <FormHelperText>{errorMessage}</FormHelperText> : null}
  </FormControl>
);

// Select that works with SAP data format { code, name }
const SapSelectField = ({
  label,
  fieldKey,
  options = [],
  value,
  onChange,
  required = true,
  disabled = false,
  error = false,
  errorMessage = "",
}) => {
  return (
    <FormControl fullWidth margin="normal" size="small" required={required} disabled={disabled} error={error}>
      <InputLabel required={required}>{label}</InputLabel>
      <Select
        value={value?.code || ""}
        label={label}
        onChange={(e) => {
          const opt = options?.find(
            (o) => String(o.code) === String(e.target.value)
          );
          onChange(
            fieldKey,
            opt
              ? {
                   // SAP fields don't have ObjectId, so send null
                  code: opt.code || "",
                  label: opt.name || "",
                }
              : {  code: "", label: "" }
          );
        }}
      >
        {options?.map((item) => (
          <MenuItem key={item.code} value={item.code || ""}>
            {item.name || ""}{" "}
            {item.code ? `(${item.code})` : ""}
          </MenuItem>
        ))}
      </Select>
      {error && errorMessage ? <FormHelperText>{errorMessage}</FormHelperText> : null}
    </FormControl>
  );
};

const TextFieldInput = ({
  label,
  fieldKey,
  value,
  onChange,
  type = "text",
  placeholder,
  helperText,
  required = true,
  error = false,
  errorMessage = "",
  InputLabelProps,
  disabled = false,
}) => {
  return (
    <TextField
      required={required}
      fullWidth
      margin="normal"
      size="small"
      label={label}
      type={type}
      value={value}
      placeholder={placeholder}
      helperText={error ? errorMessage : helperText}
      error={error}
      InputLabelProps={InputLabelProps}
      disabled={disabled}
      onChange={(e) => onChange(fieldKey, e.target.value)}
    />
  );
};

// const SectionTitle = ({ children }) => (
//   <Box
//     sx={{
//       mt: 3,
//       border: "2px ",
//       borderRadius: "18px",
//       textAlign: "start",
//       pl: 2,
//       pt: 1,
//       width: "60%",
//       backgroundColor: "rgb(253, 188, 0)",
//     }}
//   >
//     <Typography variant="h6" sx={{ fontWeight: 500,fontSize:"17px",lineHeight:"20px" }} gutterBottom>
//       {children}
//     </Typography>
//     <Divider sx={{ mb: 2 }} />
//   </Box>
// );
const SectionTitle = ({ children }) => (
  <Box sx={{ mt: 3, mb: 1 }}>
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        px: 2,
        py: 0.75,
        borderRadius: 999,
        backgroundColor: "rgb(253, 188, 0)",
        boxShadow: 1,
      }}
    >
      <Typography sx={{ fontWeight: 700, fontSize: 14, lineHeight: 1 }}>
        {children}
      </Typography>
    </Box>
    <Divider sx={{ mt: 1 }} />
  </Box>
);
const TyreBrandSelector = ({ selectedTyreGroups, onSelect }) => {
  return (
    <FormControl fullWidth margin="normal" size="small">
      <InputLabel>Tyre Brand</InputLabel>
      <Select
        value=""
        onChange={(e) => {
          const [group, value] = e.target.value.split("::");
          onSelect(group, value);
        }}
        displayEmpty
      >
        <ListSubheader>Tyre-Group-1</ListSubheader>
        {brandData["Tyre-Group-1"].map((item) => (
          <MenuItem key={item} value={`Tyre-Group-1::${item}`}>
            {item}
          </MenuItem>
        ))}

        <ListSubheader>Tyre-Group-2</ListSubheader>
        {brandData["Tyre-Group-2"].map((item) => (
          <MenuItem key={item} value={`Tyre-Group-2::${item}`}>
            {item}
          </MenuItem>
        ))}
      </Select>

      <Typography variant="body2" mt={2}>
        Group 1 Selected: {selectedTyreGroups["Tyre-Group-1"] || "None"}
        <br />
        Group 2 Selected: {selectedTyreGroups["Tyre-Group-2"] || "None"}
      </Typography>
    </FormControl>
  );
};

const DealerOnboardForm = () => {
  const history = useHistory();
  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [masterData, setMasterData] = useState({});
  const [sapData, setSapData] = useState({});
  const [userOnBoardData, setUserOnBoardData] = useState({});
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [sasValidation, setSasValidation] = useState({
    isValid: true,
    message: "",
    isDisabled: false
  });
  const [uploading, setUploading] = useState({});
  const [docPreviews, setDocPreviews] = useState({});
  const [selectedTyreGroups, setSelectedTyreGroups] = useState({
    "Tyre-Group-1": "",
    "Tyre-Group-2": "",
  });

  const [disableSubmit, setDisableSubmit] = useState(false);

  // Get prospect data from navigation state
  const prospectData = getNavigationState();
  const dealerId = getDealerId();

  console.log("dealerIdprospectData", prospectData);
  // Always show all fields - no hiding logic
  const shouldShowFields = true;
  

  // Resolve prospectId once and keep it stable for deps
  const prospectId = useMemo(() => {
    const st = getNavigationState();
    return st?._id || st?.prospectId || dealerId || null;
  }, [dealerId]);
  const storageKey = useMemo(
    () => makeDealerOnboardStorageKey(dealerId, prospectId),
    [dealerId, prospectId]
  );

  useEffect(() => {
    const persisted = loadPersistedDealerOnboard(storageKey);
    if (persisted?.formData) {
      setFormData((prev) => ({ ...prev, ...persisted.formData }));
    }
    if (persisted?.docPreviews) {
      setDocPreviews(persisted.docPreviews || {});
    }
   
  }, [storageKey]);

  // Fetch prospect data with approval status
  const fetchProspectData = async () => {
    try {
      const token = getAuthToken();
      if (!token) return null;

      const response = await fetch(
        `${REACT_APP_REQUEST_ENDPOINT}/api/v1/actyv/prospects/dealer/searchprospect?search=${prospectId || dealerId || ""}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );
 
      if (!response.ok) return null;
      
      const data = await response.json();
      console.log("datadata", data);

      // Find the prospect with matching ID
      const prospect = data.dealerProspects
     
      if (prospect) {
        console.log("prospectprospect", prospect);
        setUserOnBoardData(prospect);
        let lat = prospect.basicInfo.location.lat;
        let long = prospect.basicInfo.location.long;
        let dealership_name = prospect.businessInfo.dealershipName;
        let mobile_phone = prospect.businessInfo.phoneNumber;
        setFormData(prev => {
          const next = {
            ...prev,
            latitude:  { ...(prev.latitude  || {}), code: String(lat) },
            longitude: { ...(prev.longitude || {}), code: String(long) }, // or String(long) if that's your var
            dealership_name: { ...(prev.dealership_name || {}), code: String(dealership_name) },
            mobile_phone: { ...(prev.mobile_phone || {}), code: String(mobile_phone) },
          };
          // optional: persist if you're using session storage
          // try { savePersistedDealerOnboard(storageKey, { formData: next, docPreviews }); } catch (_) {}
          return next;
        });          }
      // setFormData((e)=>({...e, contact_person: {code: prospect?.basicInfo.firstPersonContact.name}}))

      
      return null;
    } catch (error) {
      console.error("Failed to fetch prospect data:", error);
      return null;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      // Mark as loading initially
      setIsDataLoaded(false);
     

      const fetchSapData = async () => {
        try {
          const fallbackData = await getCustomerGroupData();
          
        //   if (sapRes?.data) {
        //     setSapData(sapRes.data);
        //     console.log("SAP data loaded:", sapRes.data);
        //   }
        // } catch (err) {
        //   console.warn("SAP API failed, trying fallback onboarding API:", err);
        //   // Fallback to onboarding API
        //   try {
        //     const fallbackResponse = await fetch(`${REACT_APP_REQUEST_ENDPOINT}/api/v1/actyv/onboarding`);
        //     const fallbackData = await fallbackResponse.json();
            
            console.log("fallbackDatafallbackData", fallbackData);
            if (fallbackData?.data) {
              // Transform fallback data to match SAP format
              const transformedData = {
                customer_group: fallbackData.data.customer_group?.map(item => ({
                  code: item.code,
                  name: item.name
                })) || [],
                price_group:fallbackData.data.price_group?.map(item => ({
                  code: item.code,
                  name: item.description
                })) || [],
                price_list:fallbackData.data.price_list?.map(item => ({
                  code: item.code,
                  name: item.description
                })) || [],
                account_group:fallbackData.data.account_group?.map(item => ({
                  code: item.code,
                  name: item.description
                })) || [],
                account_assignment_group:fallbackData.data.account_assignment_group?.map(item => ({
                  code: item.code,
                  name: item.description
                })) || [],
                // reconciliation_account:fallbackData.data.reconciliation_account?.map(item => ({
                //   code: item.code,
                //   name: item.description
                // })) || [],
                customer_pricing_procedure: fallbackData.data.customer_pricing_procedure?.map(item => ({
                  code: item.code,
                  name: item.description
                })) || [],
                terms_of_payment: fallbackData.data.terms_of_payment?.map(item => ({
                  code: item.code,
                  name: item.description
                })) || [],
                // incoterms: fallbackData.data.incoterms?.map(item => ({
                //   code: item.code,
                //   name: item.description
                // })) || [],
                sales_office: fallbackData.data.sales_office?.map(item => ({
                  code: item.code,
                  name: item.description
                })) || [],
                distribution_channel: fallbackData.data.distribution_channel?.map(item => ({
                  code: item.code,
                  name: item.description
                })) || [],
                // division: fallbackData.data.division?.map(item => ({
                //   code: item.code,
                //   name: item.description
                // })) || [],
                state: fallbackData.data.state?.map(item => ({
                  code: item.code,
                  name: item.description
                })) || [],
                customer_class: fallbackData.data.customer_class?.map(item => ({
                  code: item.code,
                  name: item.description
                })) || [],
                status: fallbackData.data.status?.map(item => ({
                  code: item.code,
                  name: item.description
                })) || []
              };
              
              setSapData(transformedData);
              console.log("Fallback onboarding data loaded:", transformedData);
            }
          } catch (fallbackError) {
            console.warn("Fallback onboarding API also failed:", fallbackError);
          }
        // }
      };

      // Load saved onboarding form from backend and prefill
      const fetchSavedOnboardData = async () => {
        try {
          const token = getAuthToken();
          const id = prospectId || dealerId;
          if (!token || !id) return;
          const url = `${REACT_APP_REQUEST_ENDPOINT}/api/v1/actyv/onboarding/user?prospectId=${encodeURIComponent(id)}`;
          const res = await fetch(url, {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          });

          if (!res.ok) return;
          const json = await res.json().catch(() => ({}));
          const formObj =
            json?.data?.form ||
            json?.form ||
            (json?.data && typeof json.data === "object" ? json.data : null);

            if(formObj.userOnBoard){
              setDisableSubmit(true);
            }
          if (formObj && typeof formObj === "object") {
            const normalized = normalizeIncomingForm(formObj);

            setFormData((prev) => {
              const next = { ...prev, ...normalized };
              // savePersistedDealerOnboard(storageKey, {
              //   formData: next,
              //   docPreviews,
              // });
              return next;
            });
          }
        } catch (_) {
          // ignore
        }
      };


      const fetchProspectDataAsync = async () => {
        try {
          const prospectRes = await fetchProspectData();
          

        } catch (err) {
          // Prospect data fetch failed, continue without it
        }
      };


      // Execute all API calls independently
      await Promise.allSettled([
        fetchSavedOnboardData(),
        // fetchMasterData(),
        fetchSapData(),
        fetchProspectDataAsync(),
        // fetchDealerOnboardData()
      ]);

      // Always mark as loaded, regardless of API results
      setIsDataLoaded(true);
    };

    fetchData();
  }, [prospectId, dealerId]);

  // Validation helpers
  const validateField = (key, valueOverride) => {
    const rules = validationRules[key];
    if (!rules || !Array.isArray(rules)) return null;
    const value = valueOverride !== undefined ? valueOverride : formData[key];
    for (const rule of rules) {
      if (typeof rule.fn === "function") {
        const passed = rule.fn(value);
        if (!passed) return rule.message || "Invalid value.";
      }
    }
    return null;
  };

  const validateAll = (data = formData) => {
    const nextErrors = {};
    Object.keys(validationRules).forEach((key) => {
      const message = validateField(key, data[key]);
      if (message) nextErrors[key] = message;
    });
    return nextErrors;
  };

  const fieldProps = (key) => ({
    error: !!errors[key],
    errorMessage: errors[key] || "",
  });

  // Normalize DB/API payload to our { code, label } structure per key
  const normalizeIncomingForm = (incoming = {}) => {
    const result = {};
    Object.keys(initialFormData).forEach((key) => {
      const val = incoming[key];
      if (val !== undefined && val !== null) {
        if (typeof val === "object" && !Array.isArray(val)) {
          // Prefer common shapes: code/label, name/value/text, plus imageUrl variants
          const codeCandidate =
            val.code ??
            val.label ?? // sometimes label holds value
            val.name ??
            val.value ??
            val.text ??
            "";
          const labelCandidate = val.label ?? val.name ?? "";
          result[key] = {
            code: codeCandidate != null ? String(codeCandidate) : "",
            label: labelCandidate != null ? String(labelCandidate) : "",
            imageUrl: val.imageUrl || val.ImageUrl || val.imgUrl || "",
          };
        } else {
          // Primitive → treat as text
          result[key] = { code: String(val), label: "", imageUrl: "" };
        }
      } 
    });
    return result;
  };


  // SAS validation function - simplified, no approval status checks
  const validateSAS = (sasValue) => {
    const numericValue = parseFloat(sasValue);
    
    // Always allow submission, just show warning for low values
    if (isNaN(numericValue) || numericValue < 100000) {
      return {
        isValid: false, // Show error for very low values
        message: "SAS → Minimum SAS should be above the INR 2,99,999. Exception approval provision for INR 100000 & above but less than INR 2,99,999",
        isDisabled: false
      };
    } else if (numericValue >= 100000 && numericValue < 299999) {
      return {
        isValid: true, // Allow submission but show approval needed
        message: "Exception approval provision for INR 100000 & above but less than INR 2,99,999",
        isDisabled: false
      };
    } else {
      return {
        isValid: true,
        message: "",
        isDisabled: false
      };
    }
  };

  // Accept object for Selects, string for TextFields
  const handleFieldChange = (fieldKey, value) => {
    console.log("valuevalue", value);
    const newValue =
      value && typeof value === "object"
        ? value
        : { ...(formData[fieldKey] || {}), code: value };
    const nextFormData = {
      ...formData,
      [fieldKey]: newValue,
    };
    setFormData(nextFormData);
    savePersistedDealerOnboard(storageKey, {
      formData: nextFormData,
      docPreviews,
    });

    setTouched((prev) => ({ ...prev, [fieldKey]: true }));
    if (validationRules[fieldKey]) {
      const message = validateField(fieldKey, newValue);
      setErrors((prev) => {
        const n = { ...prev };
        if (message) n[fieldKey] = message;
        else delete n[fieldKey];
        return n;
      });
    }

    // Validate SAS field
    if (fieldKey === "with_sas") {
      const validation = validateSAS(value);
      setSasValidation(validation);
    }
  };

  
const handleSubmit = async () => {
console.log("formDataformData", formData);  // Touch all fields and validate before preview
  const allTouched = Object.keys(formData).reduce((acc, k) => {
    acc[k] = true;
    return acc;
  }, {});
  setTouched(allTouched);
  const nextErrors = validateAll(formData);
  setErrors(nextErrors);
  console.log("nextErrorsnextErrors", nextErrors,formData);
  if (Object.keys(nextErrors).length > 0) {
    toastMessage("Please fix highlighted errors before pre.", "error");
    return;
  }
  // Navigate to preview with state
  history.push("/actyv-ai/dealer-form/preview", {
    formData,
    sapData,
    prospectData,
    dealerId,
    prospectId,
    docPreviews,
  });
}

  const handleCancel = () => {
    window.history.back();
  };

  const uploadFile = async (e) => {
    const file = e.target.files[0];
    const fieldName = e.target.name;
    
    if (!file) return;
  
    try {
      // Client-side file validation
      if (file.size > MAX_FILE_SIZE) {
        setErrors((prev) => ({ ...prev, [fieldName]: "File must be 5 MB or smaller." }));
        toastMessage("File too large (max 5 MB).", "error");
        return;
      }
      if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
        setErrors((prev) => ({ ...prev, [fieldName]: "Only JPG, PNG, WEBP, or GIF allowed." }));
        toastMessage("Unsupported file type.", "error");
        return;
      }

      // start loader and set local preview
      setUploading((prev) => ({ ...prev, [fieldName]: true }));
      try {
        // revoke old url if exists
        if (docPreviews[fieldName]) {
          try { URL.revokeObjectURL(docPreviews[fieldName]); } catch (_) {}
        }
      } catch (_) {}
      const localPreviewUrl = URL.createObjectURL(file);
      setDocPreviews((prev) => {
        const next = { ...prev, [fieldName]: localPreviewUrl };
        savePersistedDealerOnboard(storageKey, {
          formData,
          docPreviews: next,
        });
        return next;
      });

      const formDataToSend = new FormData();
      formDataToSend.append("image", file);
  
      
      const token = localStorage.getItem("token");  

      // 1) Upload to legacy preview API to get image URL (best-effort)
  
        const resPreview = await fetch(`${process.env.REACT_APP_REQUEST_ENDPOINT}/api/v1/utils/uploadFile`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formDataToSend,
        });
       
        const previewJson = await resPreview.json()
        console.log(previewJson,"previewJsonpreviewJson")
        if (resPreview.ok && previewJson?.imgUrl) {
          // Persist imageUrl for future displays and replace preview with remote URL
          setFormData((prev) => {
            const next = {
              ...prev,
              [fieldName]: {
                ...prev[fieldName],
                imageUrl: previewJson.imgUrl,
              },
            };
           
            savePersistedDealerOnboard(storageKey, {
              formData: next,
              docPreviews,
            });
            return next;
          });
          console.log(formData,"formData")
          setDocPreviews((prev) => {
            const next = { ...prev, [fieldName]: previewJson.imgUrl };
            savePersistedDealerOnboard(storageKey, {
              formData,
              docPreviews: next,
            });
            return next;
          });
        }
       

      // 2) Upload to onboarding API to get docNo
      const response = await fetch(`${process.env.REACT_APP_REQUEST_ENDPOINT}/api/v1/actyv/onboarding/upload-document`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formDataToSend,
      });
  
      const data = await response.json();
      console.log("upload-document response", data);

      // New API returns { docNo: string, ... }
      if (data?.docNo) {
        setFormData((prev) => {
          const next = {
            ...prev,
            [fieldName]: {
              ...prev[fieldName],
              code: data.docNo,   // store doc number in code as requested
            },
          };
          savePersistedDealerOnboard(storageKey, {
            formData: next,
            docPreviews,
          });
          return next;
        });
        // Clear previous error for this field on success
        setErrors((prev) => {
          const n = { ...prev };
          delete n[fieldName];
          return n;
        });
      } else {
        console.error("Upload failed: No docNo returned");
        setErrors((prev) => ({ ...prev, [fieldName]: "Upload failed. Try again." }));
        toastMessage("Upload failed. Please try again.", "error");
      }
    } catch (error) {
      console.error("Error uploading GST certificate:", error);
      setErrors((prev) => ({ ...prev, [fieldName]: "Upload failed. Try again." }));
      toastMessage("Upload failed. Please try again.", "error");
    } finally {
      setUploading((prev) => ({ ...prev, [fieldName]: false }));
    }
  };
  

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Paper
        sx={{
          p: 4,
          borderRadius: 3,
          boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
          backgroundColor: "#fff",
        }}
      >
        <Box
          sx={{
            mb: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          <Box>
            <Typography
              variant="h4"
              sx={{ fontWeight: 700, letterSpacing: 0.2 }}
            >
              Add DEALER
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Fill the customer onboarding details. Fields marked * are
              required.
            </Typography>
          </Box>


          {/* <Stack direction="row" spacing={1}>
            <Button variant="outlined" onClick={handleCancel}>Cancel</Button>
            <Button
              variant="contained"
              onClick={handleSubmit}
              sx={{ backgroundColor: 'rgb(253, 188, 0)', color: 'black', fontWeight: 700 }}
            >
              Submit
            </Button>
          </Stack> */}
        </Box>

        {/* {prospectData && (
          <Box sx={{ mb: 3, p: 2, bgcolor: "grey.100", borderRadius: 1 }}>
            <Typography variant="h6" gutterBottom>
              Prospect Information
            </Typography>
            <Typography variant="body2">From: {prospectData.from}</Typography>
            <Typography variant="body2">
              Prospect ID: {prospectData.prospectId}
            </Typography>
            <Typography variant="body2">
              Dealer ID: {dealerId || "—"}
            </Typography>
          </Box>
        )} */}

        {!isDataLoaded && (
          <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center', 
            py: 8,
            gap: 2
          }}>
            <CircularProgress size={40} />
            <Typography variant="body1" color="text.secondary">
              Loading form data...
            </Typography>
          </Box>
        )}
        
        
        <Grid container columnSpacing={3} rowSpacing={2}>
          {/* SAP & Pricing Section */}
          <Grid item xs={12}>
            <SectionTitle>SAP &amp; Pricing</SectionTitle>
          </Grid>
          {/* Customer Group */}
          <Grid item xs={12} md={6}>
            <SapSelectField
              label="Customer Group"
              fieldKey="customer_group"
              // options={sapData.customerGrp || []}
              options={sapData.customer_group || []}
              value={formData.customer_group}
              onChange={handleFieldChange}
              {...fieldProps("customer_group")}
            />
          </Grid>

          {/* Customer Pricing Procedure */}
          <Grid item xs={12} md={6}>
            <SapSelectField
              label="Customer Pricing Procedure"
              fieldKey="customer_pricing_procedure"
              // options={sapData.customerPriceProc || []}
              options={sapData.customer_pricing_procedure || []}
              value={formData.customer_pricing_procedure}
              onChange={handleFieldChange}
              {...fieldProps("customer_pricing_procedure")}
            />
          </Grid>

          {/* Terms of Payment */}
          <Grid item xs={12} md={6}>
            <SapSelectField
              label="Terms of Payment"
              fieldKey="terms_of_payment"
              // options={sapData.payTerms || []}
              options={sapData.terms_of_payment || []}
              value={formData.terms_of_payment}
              onChange={handleFieldChange}
              {...fieldProps("terms_of_payment")}
            />
          </Grid>

          {/* Incoterms */}
          {/* <Grid item xs={12} md={6}>
            <SapSelectField
              label="Incoterms"
              fieldKey="incoterms"
              // options={sapData.incoTerms || []}
              options={sapData.incoterms || []}
              value={formData.incoterms}
              onChange={handleFieldChange}
            />
          </Grid> */}

          {/* Account Assignment Group */}
          <Grid item xs={12} md={6}>
            <SapSelectField
              label="Account Assignment Group"
              fieldKey="account_assignment_group"
              options={sapData.account_assignment_group || []}
              value={formData.account_assignment_group}
              onChange={handleFieldChange}
              {...fieldProps("account_assignment_group")}
            />
          </Grid>

          {/* Reconciliation Account */}
          {/* <Grid item xs={12} md={6}>
            <SapSelectField
              label="Reconciliation Account"
              fieldKey="reconciliation_account"
              options={sapData.reconciliation_account || []}
              value={formData.reconciliation_account}
              onChange={handleFieldChange}
              {...fieldProps("reconciliation_account")}
            />
          </Grid> */}

          {/* Org Structure Section */}
          <Grid item xs={12}>
            <SectionTitle>Org Structure</SectionTitle>
          </Grid>
          {/* Account Group */}
          <Grid item xs={12} md={6}>
            <SapSelectField
              label="Account Group"
              fieldKey="account_group"
              // options={masterData.account_group || []}
              options={sapData.account_group || []}
              value={formData.account_group}
              onChange={handleFieldChange}
              {...fieldProps("account_group")}
            />
          </Grid>
          {/* Company Code */}
          {/* <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Company Code"
              fieldKey="company_code"
              value={formData.company_code.code}
              onChange={handleFieldChange}
              {...fieldProps("company_code")}
            />
          </Grid> */}
          {/* Sales Org */}
          {/* <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Sales Org"
              fieldKey="sales_org"
              value={formData.sales_org.code}
              onChange={handleFieldChange}
              {...fieldProps("sales_org")}
            />
          </Grid> */}

          {/* Sales Office */}
          <Grid item xs={12} md={6}>
            <SapSelectField
              label="Sales Office"
              fieldKey="sales_office"
              // options={sapData.salesOffice || []}
              options={sapData.sales_office || []}
              value={formData.sales_office}
              onChange={handleFieldChange}
              {...fieldProps("sales_office")}
            />
          </Grid>

          {/* Distribution Channel */}
          <Grid item xs={12} md={6}>
            <SapSelectField
              label="Distribution Channel"
              fieldKey="distribution_channel"
              // options={sapData.distributionChannel || []}
              options={sapData.distribution_channel || []}
              value={formData.distribution_channel}
              onChange={handleFieldChange}
              {...fieldProps("distribution_channel")}
            />
          </Grid>
          {/* With SAS */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="With SAS"
              fieldKey="with_sas"
              value={formData.with_sas.code}
              onChange={handleFieldChange}
              type="number"
              error={!sasValidation.isValid}
              errorMessage={sasValidation.message}
            />
            
            {/* SAS Warning Indicator */}
            {formData.with_sas.code && parseFloat(formData.with_sas.code) < 299999 && (
              <Box sx={{ mt: 2, p: 2, borderRadius: 1, bgcolor: 'warning.light', border: '1px solid', borderColor: 'warning.main' }}>
                <Typography variant="body2" sx={{ fontWeight: 600, color: 'warning.dark' }}>
                  ⚠️ SAS value is below 3 lakhs. Approval email will be sent for processing.
                </Typography>
              </Box>
            )}
          </Grid>
          {/* Title */}
          {/* <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Title"
              fieldKey="title"
              value={formData.title.code}
              onChange={handleFieldChange}
              {...fieldProps("title")}
            />
          </Grid> */}

          {/* Customer Classification Section */}
          <Grid item xs={12}>
            <SectionTitle>Customer Classification</SectionTitle>
          </Grid>
          {/* Division */}
          {/* <Grid item xs={12} md={6}>
            <SapSelectField
              label="Division"
              fieldKey="division"
              options={sapData.division || []}
              value={formData.division}
              onChange={handleFieldChange}
            />
          </Grid> */}

          {/* State */}
          <Grid item xs={12} md={6}>
            <SapSelectField
              label="State"
              fieldKey="state"
              options={sapData.state || []}
              value={formData.state}
              onChange={handleFieldChange}
              {...fieldProps("state")}
            />
          </Grid>

          {/* Customer Class */}
          <Grid item xs={12} md={6}>
            <SapSelectField
              label="Customer Class"
              fieldKey="customer_class"
              // options={sapData.customerClass || []}
              options={sapData.customer_class || []}
              value={formData.customer_class}
              onChange={handleFieldChange}
              {...fieldProps("customer_class")}
            />
          </Grid>

          {/* Status */}
          <Grid item xs={12} md={6}>
            <SapSelectField
              label="Entity"
              fieldKey="status"
              // options={sapData.customerStatus || []}
              options={sapData.status || []}
              value={formData.status}
              onChange={handleFieldChange}
              {...fieldProps("status")}
            />
          </Grid>

          {/* Price Group */}
          <Grid item xs={12} md={6}>
            <SapSelectField
              label="Price Group"
              fieldKey="price_group"
              // options={PRICE_GROUP_OPTIONS}
              options={sapData.price_group || []}
              value={formData.price_group}
              onChange={handleFieldChange}
              {...fieldProps("price_group")}
            />
          </Grid>

          {/* Price List */}
          <Grid item xs={12} md={6}>
            <SapSelectField
              label="Price List"
              fieldKey="price_list"
              // options={PRICE_LIST_OPTIONS}
              options={sapData.price_list || []}
              value={formData.price_list}
              onChange={handleFieldChange}
              {...fieldProps("price_list")}
            />
          </Grid>

          {/* Address Section */}
          <Grid item xs={12}>
            <SectionTitle>Address</SectionTitle>
          </Grid>
          {/* dealership_name */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Dealership Name"
              fieldKey="dealership_name"
              value={formData.dealership_name.code}
              onChange={handleFieldChange}
              disabled
              {...fieldProps("dealership_name")}
            />
          </Grid>
          {/* dealership_add */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Dealership Address"
              fieldKey="dealership_add"
              value={formData.dealership_add.code}
              onChange={handleFieldChange}
              {...fieldProps("dealership_add")}
            />
          </Grid>
          {/* Street/House No. */}
          {/* <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Street/House No."
              fieldKey="street_house_no"
              value={formData.street_house_no.code}
              onChange={handleFieldChange}
              {...fieldProps("street_house_no")}
            />
          </Grid> */}
          {/* C/O */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="C/O"
              fieldKey="care_of"
              value={formData.care_of.code}
              onChange={handleFieldChange}
            />
          </Grid>
          {/* Street 2 */}
          {/* <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Street 2"
              fieldKey="street2"
              value={formData.street2.code}
              onChange={handleFieldChange}
            />
          </Grid> */}
          {/* Street 3 */}
          {/* <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Street 3"
              fieldKey="street3"
              value={formData.street3.code}
              onChange={handleFieldChange}
            />
          </Grid> */}
          {/* Street 5 */}
          {/* <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Street 5"
              fieldKey="street5"
              value={formData.street5.code}
              onChange={handleFieldChange}
            />
          </Grid> */}

          {/* Tyre Brand Selector (optional) */}
          {/* <Grid item xs={12} md={6}>
            <TyreBrandSelector
              selectedTyreGroups={selectedTyreGroups}
              onSelect={handleTyreGroupSelect}
            />
          </Grid> */}

          {/* Contact Section */}
          <Grid item xs={12}>
            <SectionTitle>Contact</SectionTitle>
          </Grid>
     

          {/* Contact Person */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Dealer name"
              fieldKey="contact_person"
              value={formData.contact_person.code}
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Phone Number */}
          {/* <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Landline Number"
              fieldKey="phone_number"
              value={formData.phone_number.code}
              placeholder="9876543210"
              helperText="Primary contact number"
              onChange={handleFieldChange}
              {...fieldProps("phone_number")}
            />
          </Grid> */}

          {/* Email */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Email"
              fieldKey="email"
              type="email"
              value={formData.email.code}
              onChange={handleFieldChange}
              {...fieldProps("email")}
            />
          </Grid>

          {/* Address */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Address"
              fieldKey="address"
              value={formData.address.code}
              onChange={handleFieldChange}
              {...fieldProps("address")}
            />
          </Grid>

          {/* City */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="City"
              fieldKey="city"
              value={formData.city.code}
              onChange={handleFieldChange}
              {...fieldProps("city")}
            />
          </Grid>

          {/* Postal Code */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Postal Code"
              fieldKey="postal_code"
              value={formData.postal_code.code}
              placeholder="123456"
              helperText="6-digit PIN code"
              onChange={handleFieldChange}
              {...fieldProps("postal_code")}
            />
          </Grid>

          {/* Region */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Region"
              fieldKey="region"
              value={formData.region.code}
              onChange={handleFieldChange}
              {...fieldProps("region")}
            />
          </Grid>
          {/* District */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="District"
              fieldKey="district"
              value={formData.district.code}
              onChange={handleFieldChange}
              {...fieldProps("district")}
            />
          </Grid>
          {/* Different City */}
          {/* <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Different City"
              fieldKey="different_city"
              value={formData.different_city.code}
              onChange={handleFieldChange}
            />
          </Grid> */}

          {/* Mobile Phone */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Mobile Phone"
              fieldKey="mobile_phone"
              value={formData.mobile_phone.code}
              placeholder="9876543210"
              disabled
              helperText="Alternate mobile number"
              onChange={handleFieldChange}
              {...fieldProps("mobile_phone")}
            />
          </Grid>
          {/* Telephone */}
          {/* <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Telephone"
              fieldKey="telephone"
              value={formData.telephone.code}
              onChange={handleFieldChange}
            />
          </Grid> */}
          {/* FAX */}
          {/* <Grid item xs={12} md={6}>
            <TextFieldInput
              label="FAX"
              fieldKey="fax"
              value={formData.fax.code}
              onChange={handleFieldChange}
            />
          </Grid> */}

          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Passport Details"
              fieldKey="passportDetails"
              value={formData.passportDetails.code}
              onChange={handleFieldChange}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Father's Name"
              fieldKey="fatherName"
              value={formData.fatherName.code}
              onChange={handleFieldChange}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Date of Birth"
              fieldKey="dateOfBirth"
              type="date"
              value={formData.dateOfBirth.code}
              InputLabelProps={{ shrink: true }}
              onChange={handleFieldChange}
            />
          </Grid>
          {/* Tax & Compliance Section */}
          <Grid item xs={12}>
            <SectionTitle>Tax &amp; Compliance</SectionTitle>
          </Grid>
          {/* Tax Number 3 */}
          {/* <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Tax Number 3"
              fieldKey="tax_number_3"
              value={formData.tax_number_3.code}
              onChange={handleFieldChange}
            />
          </Grid> */}
          {/* PAN */}
               {/* GST Number */}
               
               <Grid item xs={12} md={6}>
            <TextFieldInput
              label="GST Number"
              fieldKey="gst_number"
              value={formData.gst_number.code}
              placeholder="22AAAAA0000A1Z5"
              helperText="As per GSTIN"
              onChange={handleFieldChange}
             {...fieldProps("gst_number")}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="PAN"
              fieldKey="pan"
              value={formData.pan.code}
              placeholder="ABCDE1234Q"
              helperText="10-character PAN"
              onChange={handleFieldChange}
              {...fieldProps("pan")}
            />
          </Grid>
          <Grid  item xs={12} md={6}>

          </Grid>

          {/* Uploads Section: aligned in grid */}
          <Grid item xs={12}>
            <SectionTitle>Documents</SectionTitle>
          </Grid>
          {DOCUMENT_UPLOADS.map((doc) => (
            <Grid key={doc.key} item xs={12} md={6}>
              <Typography variant="subtitle1" sx={{ mb: 1 }}>
                {doc.label}
              </Typography>
              <Button variant="contained" component="label" fullWidth sx={{ mb: 1 }}>
                {uploading[doc.key] ? (
                  <Stack direction="row" spacing={1} alignItems="center" justifyContent="center" sx={{ width: "100%" }}>
                    <CircularProgress size={18} />
                    <Typography variant="button" sx={{ fontWeight: 700 }}>Uploading...</Typography>
                  </Stack>
                ) : (
                  `Upload ${doc.label}`
                )}
                <input hidden accept="image/*" type="file" name={doc.key} onChange={uploadFile} />
              </Button>
              {errors[doc.key] ? <FormHelperText error>{errors[doc.key]}</FormHelperText> : null}
              {formData[doc.key].code ? (
                (docPreviews[doc.key] && !uploading[doc.key]) ? (
                  <Box
                    component="img"
                    src={docPreviews[doc.key]}
                    alt={doc.label}
                    sx={{ width: "100%", maxHeight: 200, borderRadius: 1, objectFit: "contain", border: "1px solid #ccc" }}
                  />
                ) : formData[doc.key]?.imageUrl ? (
                  <Box
                    component="img"
                    src={formData[doc.key].imageUrl}
                    alt={doc.label}
                    sx={{ width: "100%", maxHeight: 200, borderRadius: 1, objectFit: "contain", border: "1px solid #ccc" }}
                  />
                ) : isHttpUrl(formData[doc.key].code) ? (
                  <Box
                    component="img"
                    src={formData[doc.key].code}
                    alt={doc.label}
                    sx={{ width: "100%", maxHeight: 200, borderRadius: 1, objectFit: "contain", border: "1px solid #ccc" }}
                  />
                ) : (
                  <Box
                    sx={{
                      width: "100%",
                      p: 2,
                      borderRadius: 1,
                      border: "1px solid #ccc",
                      bgcolor: "grey.50",
                    }}
                  >
                    <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
                      Document Number
                    </Typography>
                    <Typography variant="body2" sx={{ wordBreak: "break-all" }}>
                      {formData[doc.key].code}
                    </Typography>
                  </Box>
                )
              ) : null}
            </Grid>
          ))}




          {/* Commercial Settings Section */}
          <Grid item xs={12}>
            <SectionTitle>Commercial Settings</SectionTitle>
          </Grid>
          {/* Customer Statistic Group */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Customer Statistic Group"
              fieldKey="customer_statistic_group"
              value={formData.customer_statistic_group.code}
              onChange={handleFieldChange}
            />
          </Grid>
          {/* Delivering Plant */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Delivering Plant"
              fieldKey="delivering_plant"
              value={formData.delivering_plant.code}
              onChange={handleFieldChange}
            />
          </Grid>
          {/* Rebate */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Rebate"
              fieldKey="rebate"
              value={formData.rebate.code}
              onChange={handleFieldChange}
            />
          </Grid>
          {/* Incoterms1 */}
          {/* <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Incoterms1"
              fieldKey="incoterms1"
              value={formData.incoterms1.code}
              onChange={handleFieldChange}
            />
          </Grid> */}

          {/* Geo & Limits Section */}
          <Grid item xs={12}>
            <SectionTitle>Geo &amp; Limits</SectionTitle>
          </Grid>
          {/* Latitude */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Latitude"
              fieldKey="latitude"
              value={formData.latitude.code}
              disabled
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Longitude */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Longitude"
              fieldKey="longitude"
              value={formData.longitude.code}
              disabled
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Credit Limit */}
          {/* <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Credit Limit"
              fieldKey="credit_limit"
              type="number"
              value={formData.credit_limit.code}
              onChange={handleFieldChange}
            />
          </Grid> */}

          {/* Account Manager */}
          {/* <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Account Manager"
              fieldKey="account_manager"
              value={formData.account_manager.code}
              onChange={handleFieldChange}
            />
          </Grid> */}
        </Grid>
        {/* Extras Section: aligned container */}
        <Grid container columnSpacing={3} rowSpacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12}>
            <SectionTitle>Extras</SectionTitle>
          </Grid>
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Population of the city"
              fieldKey="populationOfCity"
              value={formData.populationOfCity.code}
              onChange={handleFieldChange}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Regional Office"
              fieldKey="regionalOffice"
              value={formData.regionalOffice.code}
              onChange={handleFieldChange}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="No. of Years in Business (Tyre only)"
              fieldKey="noOfYearsBusiness"
              value={formData.noOfYearsBusiness.code}
              onChange={handleFieldChange}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Shop Status"
              fieldKey="shopStatus"
              value={formData.shopStatus.code}
              onChange={handleFieldChange}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Nearest JK Dealer (KM)"
              fieldKey="nearestJKDealer"
              value={formData.nearestJKDealer.code}
              onChange={handleFieldChange}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Nearest Steel Wheel (KM)"
              fieldKey="nearestSteelWheel"
              value={formData.nearestSteelWheel.code}
              onChange={handleFieldChange}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Competition Brand Shop (KM)"
              fieldKey="competitionBrandShop"
              value={formData.competitionBrandShop.code}
              onChange={handleFieldChange}
            />
          </Grid>
          <Grid item xs={12} md={6} />
        </Grid>
        {/* Sticky Action Bar */}
        <Box
          sx={{
            position: "sticky",
            bottom: 0,
            pt: 2,
            mt: 4,
            background: (theme) =>
              `linear-gradient(180deg, rgba(255,255,255,0) 0%, ${theme.palette.background.paper} 40%)`,
          }}
        >
          <Divider sx={{ mb: 2 }} />
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            sx={{
              justifyContent: "flex-end",
              alignItems: { xs: "stretch", sm: "center" },
            }}
          >
            <Button variant="outlined" size="large" onClick={handleCancel}>
              Cancel
            </Button>
            <Button
              variant="contained"
              size="large"
              
              disabled={disableSubmit}
              sx={{
                backgroundColor: "rgb(253, 188, 0)",
                color: "black",
                fontWeight: 700,
              }}
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </Stack>
        </Box>
      </Paper>
    </Container>
  );
};

const brandYellow = "rgb(253, 188, 0)";

const actyvTheme = createTheme({
  palette: {
    primary: { main: brandYellow, contrastText: "#000" },
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#e0e0e0",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: brandYellow,
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: brandYellow,
            borderWidth: 2,
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          "&.Mui-focused": {
            color: brandYellow,
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        icon: {
          color: brandYellow,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          // text selection background inside inputs
          "&::selection": {
            backgroundColor: brandYellow,
            color: "#000",
          },
        },
      },
    },
  },
});

const DealerOnboardFormData = () => {
  return (
    <ThemeProvider theme={actyvTheme}>
      <AccessController roles={["RO", "ZO", "ADMIN", "AO"]}>
        <DashGridL2 Top={TopBar} Main={DealerOnboardForm} />
        <Toaster />
      </AccessController>
    </ThemeProvider>
  );
};

export default DealerOnboardFormData;





